<template>
  <div>
    <tasks-toolbar/>
  </div>
</template>

<script>
import TasksToolbar from "@/components/common/TasksToolbar.vue";
import { mapGetters } from "vuex";

export default {
  components: { TasksToolbar },
  computed: {
    ...mapGetters("authentication", {
      user: "user"
    })
  }
};
</script>

<style>
</style>
